module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_SalaoFestas333.52844caa.jpg";